module.exports = __webpack_public_path__ + "img/bunnynet-logo-dark.21073476.svg";